/**
 * Hitstop (TKT-029): congela el sprite del atacante 60-90 ms al impacto.
 *
 * No congelamos a todos los sprites — eso causaría desincronización con el
 * server (riesgo mencionado en el ticket §riesgos). Sólo el atacante local
 * recibe el freeze visual; la posición autoritativa se restaura al expirar.
 */

const DEFAULT_HITSTOP_MS = 80;

export interface HitstopFrozen {
  entityId: string;
  /** Posición snapshot al congelar. */
  frozenAt: { x: number; y: number };
  /** Reloj de pared del cliente cuando expira. */
  expiresAt: number;
}

export class HitstopController {
  private active = new Map<string, HitstopFrozen>();
  private now: () => number;

  constructor(now: () => number = () => performance.now()) {
    this.now = now;
  }

  trigger(
    entityId: string,
    position: { x: number; y: number },
    durationMs = DEFAULT_HITSTOP_MS,
  ): void {
    const clamped = Math.max(60, Math.min(90, durationMs));
    this.active.set(entityId, {
      entityId,
      frozenAt: { ...position },
      expiresAt: this.now() + clamped,
    });
  }

  /**
   * Devuelve la posición congelada si la entidad está dentro de la ventana;
   * si ya expiró, limpia y devuelve null.
   */
  getFrozen(entityId: string): { x: number; y: number } | null {
    const f = this.active.get(entityId);
    if (!f) return null;
    if (this.now() >= f.expiresAt) {
      this.active.delete(entityId);
      return null;
    }
    return f.frozenAt;
  }

  clear(): void {
    this.active.clear();
  }
}

export { DEFAULT_HITSTOP_MS };
